import { Controller } from "@hotwired/stimulus"
import { nette, cellules, prixPublicPourNet, nombre, arrondi, formatTnd } from "../lib/prix"

// Le bloc de prix d'une offre, recalculé à la frappe : le Prestataire tape ce
// qu'il veut toucher, BEB fixe le prix public (dinar supérieur), et le
// tableau dit ce que chaque vente donne, canal par canal. Les taux arrivent
// en valeurs (prix_detail_attrs), jamais en dur ici ; les formules sont dans
// lib/prix.js, partagées avec l'éditeur de cours, et sont celles d'ApercuPrix
// qui remplit les mêmes cellules côté serveur.
// ⛔ Le prix soumis est TOUJOURS le prix public écrit dans le champ ttc, en
// lecture seule pour l'utilisateur : le champ « ce que vous voulez toucher »
// n'a pas d'attribut name. Le Prestataire ne fixe jamais le prix (CGU 9 bis.1).
export default class extends Controller {
  static targets = ["ttc", "net", "cellule"]
  static values = { taux: Number, tvaBeb: Number, cession: Number, part: Number, fraisCarte: Number, retenue: Number }

  connect() {
    if (this.hasTtcTarget) this.depuisTtc()
  }

  get taux() {
    return { taux: this.tauxValue, tva_beb: this.tvaBebValue, cession: this.cessionValue,
             part: this.partValue, frais_carte: this.fraisCarteValue, retenue_honoraires: this.retenueValue }
  }

  // Le prix public a changé (au chargement, ou réécrit par depuisNet) : les
  // cellules suivent, et le net affiché aussi, sauf sous les doigts.
  depuisTtc() {
    const ttc = nombre(this.ttcTarget.value)
    this.recopier(this.hasNetTarget && this.netTarget, ttc === null ? null : nette(ttc, this.taux))
    this.afficher(ttc)
  }

  // Saisie du net voulu : BEB en déduit le prix public.
  depuisNet() {
    this.ecrireTtc(prixPublicPourNet(nombre(this.netTarget.value), this.taux))
  }

  // Écrit le prix public et prévient les autres contrôleurs qui écoutent ce
  // champ (book-variants synchronise price_cents sur l'événement input).
  ecrireTtc(ttc) {
    const valeur = ttc === null ? "" : arrondi(ttc)
    if (this.ttcTarget.value === valeur) { this.afficher(ttc); return }
    this.ttcTarget.value = valeur
    this.ttcTarget.dispatchEvent(new Event("input", { bubbles: true }))
  }

  // Une aide de saisie se remplit seule, sauf sous les doigts de l'utilisateur.
  recopier(champ, valeur) {
    if (!champ || document.activeElement === champ) return
    champ.value = valeur === null ? "" : arrondi(valeur)
  }

  afficher(ttc) {
    const valeurs = ttc === null || ttc <= 0 ? {} : cellules(ttc, this.taux)
    this.celluleTargets.forEach((cellule) => {
      const v = valeurs[cellule.dataset.cle]
      cellule.textContent = v === undefined ? "" : formatTnd(v)
    })
  }
}
